import React, { useState, useEffect } from 'react';
import './package.css'; // Import CSS file for styling
import TranslateText from 'translation/TranslateText';

function SupportHeader() {
  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) { // Change the threshold to 50px or any desired value
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="page-header-container">
      <div
        className="page-header section-dark"
        style={{
          backgroundImage: `url(${require("assets/img/Team.png")})`,
          height: "100vh",
          backgroundSize: "cover",
          // backgroundPosition: scrolling ? "center 50px" : "center 0px",
        }}
      />
       <div className="complete">
          <h1 className='age inq'><TranslateText text="Support Team" /></h1>
        </div>
     
    </div>
  );
}

export default SupportHeader;
